import React, { Component } from 'react';
import config from 'react-global-configuration';

class AlertaInline extends Component {

  // constructor
  constructor(props) {
    super(props);
    this.state = {
      style_fundo: {opacity: 0, display: 0},
      style_alerta: {color: 0, border: 0, background: 0},
      opacidade: 0,
      icon: '',
      mensagem: ''
    };

    this.aumentar_opacidade = this.aumentar_opacidade.bind(this);
    this.abrir = this.abrir.bind(this);
    this.diminuir_opacidade = this.diminuir_opacidade.bind(this);
    this.fechar = this.fechar.bind(this);
  }

  ComponentDidMount() {
    this.setState({
      style_fundo: {opacity: 0, display: 'none'},
       opacidade: 0,
    });
    if(this.props.tipo == 'erro') {
      this.setState({
        style_alerta: {
          color: '#a94442',
          border: '1px solid #ebccd1',
          background: '#f2dede',
        },
        icon: 'fa fa-fw fa-times-circle'
      });
    }
    if(this.props.tipo == 'success') {
      this.setState({
        style_alerta: {
          color: '#3c763d',
          border: '1px solid #dff0d8',
          background: '#d6e9c6',
        },
        icon: 'fa fa-fw fa-check'
      });
    }
    if(this.props.tipo == 'alerta') {
      this.setState({
        style_alerta: {
          color: '#8a6d3b',
          border: '1px solid #faebcc',
          background: '#fcf8e3',
        },
        icon: 'fa fa-fw fa-exclamation-triangle'
      });
    }
    if(this.props.tipo == 'informativo') {
      this.setState({
        style_alerta: {
          color: '#31708f',
          border: '1px solid #d9edf7',
          background: '#d9edf7',
        },
        icon: 'fa fa-fw fa-info-circle'
      });
    }
    setTimeout(() => {this.abrir();}, 5);   
    setTimeout(() => {this.fechar();}, 7000);      
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      style_fundo: {opacity: 0, display: 'none'},
       opacidade: 0,
    });
    if(newProps.tipo == 'erro') {
      this.setState({
        style_alerta: {
          color: '#a94442',
          border: '1px solid #ebccd1',
          background: '#f2dede',
        },
        icon: 'fa fa-fw fa-times-circle'
      });
    }
    if(newProps.tipo == 'success') {
      this.setState({
        style_alerta: {
          color: '#3c763d',
          border: '1px solid #dff0d8',
          background: '#d6e9c6',
        },
        icon: 'fa fa-fw fa-check'
      });
    }
    if(newProps.tipo == 'alerta') {
      this.setState({
        style_alerta: {
          color: '#8a6d3b',
          border: '1px solid #faebcc',
          background: '#fcf8e3',
        },
        icon: 'fa fa-fw fa-exclamation-triangle'
      });
    }
    if(newProps.tipo == 'informativo') {
      this.setState({
        style_alerta: {
          color: '#31708f',
          border: '1px solid #d9edf7',
          background: '#d9edf7',
        },
        icon: 'fa fa-fw fa-info-circle'
      });
    }
    setTimeout(() => {this.abrir();}, 5);   
    setTimeout(() => {this.fechar();}, 7000);      
  }

  diminuir_opacidade() {
    var opacidade = this.state.style_fundo.opacity;
    opacidade = opacidade - 0.1;
    this.setState({style_fundo: {opacity: opacidade, display: 'block'}});
    this.setState({opacidade: opacidade});
  }

  fechar() {
    if (this.state.opacidade > 0) {
      var interromper = setInterval(this.diminuir_opacidade, 25);
      setTimeout(() => {clearInterval(interromper); this.setState({style_fundo: {opacity: 0, display: 'none'}, opacidade: 0}); this.props.desativar()}, 255);
    }
  }

  aumentar_opacidade() {
    var opacidade = this.state.style_fundo.opacity;
    opacidade = opacidade + 0.1;
    this.setState({style_fundo: {opacity: opacidade, display: 'block'}});
    this.setState({opacidade: opacidade});
  }

  abrir() {
    var interromper = setInterval(this.aumentar_opacidade, 25);
    setTimeout(() => {clearInterval(interromper); this.setState({style_fundo: {opacity: 1, display: 'block'}, opacidade: 1});}, 250);
  }


  render() {
    return (
<div style={this.state.style_fundo}>
  <div className="alerta-container-inline" style={this.state.style_alerta}>
    <div className="row">
      <div className="col-md-11 text-left">
        <i className={this.state.icon}></i> {this.props.mensagem}
      </div>
      <div className="col-md-1 text-right">
        <div className="fechar-alerta" onClick={this.fechar}>
          <i className="fa fa-fw fa-close"></i>
        </div>
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default AlertaInline;



// WEBPACK FOOTER //
// ./src/Components/Miscelania/AlertaInline.js